export default "{\n    \"label\": \"Estado\",\n    \"options\": {\n        \"true\": \"Está activo\"\n    }\n}\n"